import React, { useState } from 'react';

// Material UI
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { DialogActions, Typography } from '@mui/material';

// Components
import TextField from '../../../../components/inputs/input';
import Modal from '../../../../components/modal/index';
import useCart from '../../../../hooks/orders/CartProvider';

const ObservationsOrder = ({ onClose, open }) => {
    const { sale: { observations }, update } = useCart();
    const [observationsText, setObservations] = useState(observations);
    const MAX_CHARACTERS = 180;

    const handleSave = () => {
        if (observations !== observationsText) {
            update({ observations: observationsText });
        }
        onClose();
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title='Observaciones de la orden'
            contentProps={{ dividers: true }}
            customButtons={() =>
                <DialogActions>
                    <Button
                        onClick={onClose}
                        color="primary"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleSave}
                        color="primary"
                        variant='contained'
                    >
                        Guardar
                    </Button>
                </DialogActions>
            }
        >
            <Grid container spacing={2}>
                <Grid size={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={5}
                        label='Observaciones'
                        name='observations'
                        value={observationsText || ""}
                        onChange={(event) => {
                            const value = event.target.value;
                            if (value.length <= MAX_CHARACTERS) {
                                setObservations(value);
                            }
                        }}
                        inputProps={{ maxLength: MAX_CHARACTERS }}
                    />
                    <Typography variant="caption" color="textSecondary" sx={{ mt: 0.5, display: 'block' }}>
                        {(observationsText || "").length} caracteres de {MAX_CHARACTERS}
                    </Typography>
                </Grid>
            </Grid>
        </Modal>
    );
}
export default ObservationsOrder;